import React from 'react';

const ActivityPage = ({ profileData }) => {
  return (
    <div>
      <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '12px' }}>
        Activity
      </h1>
      <p style={{ fontSize: '16px', color: '#666', marginBottom: '40px' }}>
        Track all your transactions and wallet activity here.
      </p>

      <div className="tokens-section">
        <div className="section-header">
          <h2 className="section-title">Recent Transactions</h2>
        </div>

        <div className="empty-state">
          <div className="empty-icon">🕒</div>
          <div className="empty-title">No activity yet</div>
          <div className="empty-description">
            Your transaction history will appear here once you start using your wallet.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityPage;
